import { internalNetworkClient } from '@terra/shared-rest-clients-internal-network';
import type { InternalNetworkContract } from '@terra/shared-contracts-internal-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

const CONFLICT_STATUS = 409;

export class InternalNetworkDiscoveryResetConflictError extends Error {
  constructor() {
    super('Stop the active discovery run before resetting discovery data');
    this.name = 'InternalNetworkDiscoveryResetConflictError';
  }
}

export const isInternalNetworkDiscoveryResetConflictError = (
  error: unknown,
): error is InternalNetworkDiscoveryResetConflictError =>
  error instanceof InternalNetworkDiscoveryResetConflictError;

export const internalNetworkDiscoveryApi = {
  getInternalNetworkDiscoveryReadiness: (networkId: string) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.getDiscoveryReadiness>(
      {
        endpointFn: (headers) =>
          internalNetworkClient.getDiscoveryReadiness({
            params: { networkId },
            ...withOrchestratorClient(headers),
          }),
      },
    ),

  resetInternalNetworkDiscoveryData: (networkId: string) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.resetDiscoveryData>({
      endpointFn: (headers) =>
        internalNetworkClient.resetDiscoveryData({
          params: { networkId },
          body: {},
          ...withOrchestratorClient(headers),
        }),
      errorHandler: (response) => {
        if (response.status === CONFLICT_STATUS) {
          throw new InternalNetworkDiscoveryResetConflictError();
        }
      },
      useBodyMessage: true,
    }),
};
